// api lib
import getApiEndpoint from '../../api/lib/getEndpoint.lib.api';

// auth lib
import getAuthToken from '../../auth/lib/getAuthToken.lib.auth';

// samson api
import getMechanicById from '@drivesally/sally-fn/lib/samson/api/getMechanicById.api.samson';

const getMechanicByIdService = ({
  mechanicId,
  token = getAuthToken('samson'),
  url = getApiEndpoint('samson'),
}) => getMechanicById({mechanicId, token, url});

export default getMechanicByIdService;
